export var Helium10Plans;
(function (Helium10Plans) {
    Helium10Plans["AlaCarte"] = "Helium10_ALaCarte";
    Helium10Plans["AlaCarteAnnual"] = "Helium10_ALaCarteAnnual";
    Helium10Plans["Enterprise"] = "Helium10_Enterprise";
    /** @deprecated use EliteQuarter or EliteAnnual instead */
    Helium10Plans["Elite"] = "Helium10_Elite";
    /** @deprecated use EliteQuarter or EliteAnnual instead */
    Helium10Plans["Elite399"] = "Helium10_Elite_399";
    Helium10Plans["EliteQuarter"] = "Helium10_Elite_Quarter";
    Helium10Plans["EliteAnnual"] = "Helium10_Elite_Annual";
    Helium10Plans["SuperchargeYourBrand"] = "Helium10_Supercharge_Your_Brand";
    Helium10Plans["SuperchargeYourBrandAnnual"] = "Helium10_Supercharge_Your_Brand_Annual";
    Helium10Plans["Diamond"] = "Helium10_Diamond";
    Helium10Plans["Diamond199"] = "Helium10_Diamond_199";
    Helium10Plans["DiamondAnnual"] = "Helium10_DiamondAnnual";
    Helium10Plans["DiamondAnnual1999"] = "Helium10_DiamondAnnual_1999";
    Helium10Plans["Diamond249"] = "Helium10_Diamond_249";
    Helium10Plans["DiamondAnnual249"] = "Helium10_DiamondAnnual_2499";
    Helium10Plans["DiamondChinese"] = "Helium10_Professional_Cn";
    Helium10Plans["DiamondChineseAnnual"] = "Helium10_Professional_Cn_Annual";
    Helium10Plans["ScaleYourBusiness"] = "Helium10_Scale_Your_Business";
    Helium10Plans["ScaleYourBusinessAnnual"] = "Helium10_Scale_Your_Business_Annual";
    Helium10Plans["AdtomicScaleYourBusinessBundle"] = "Helium10_Adtomic_And_Scale_Your_Business_Bundle";
    Helium10Plans["AdtomicScaleYourBusinessBundleAnnual"] = "Helium10_Adtomic_And_Scale_Your_Business_Bundle_Annual";
    Helium10Plans["Platinum"] = "Helium10_Platinum";
    Helium10Plans["Platinum99"] = "Helium10_Platinum_99";
    Helium10Plans["PlatinumAnnual"] = "Helium10_PlatinumAnnual";
    Helium10Plans["PlatinumAnnual999"] = "Helium10_PlatinumAnnual_999";
    Helium10Plans["PlatinumFastAction"] = "Helium10_Platinum_FastAction";
    Helium10Plans["PlatinumChinese"] = "Helium10_Entrepreneur_Cn";
    Helium10Plans["PlatinumChineseAnnual"] = "Helium10_Entrepreneur_Cn_Annual";
    Helium10Plans["StartYourBusiness"] = "Helium10_Start_Your_Business";
    Helium10Plans["StartYourBusinessAnnual"] = "Helium10_Start_Your_Business_Annual";
    Helium10Plans["Gold"] = "Helium10_Gold";
    Helium10Plans["GoldAnnual"] = "Helium10_GoldAnnual";
    Helium10Plans["Starter"] = "Helium10_Starter";
    Helium10Plans["Starter39"] = "Helium10_Starter_39";
    Helium10Plans["StarterAnnual"] = "Helium10_StarterAnnual";
    Helium10Plans["StarterAnnual339"] = "Helium10_StarterAnnual_339";
    Helium10Plans["StarterChinese"] = "Helium10_Explorer_Cn";
    Helium10Plans["StarterChineseAnnual"] = "Helium10_Explorer_Cn_Annual";
    Helium10Plans["Free"] = "Helium10_Free";
})(Helium10Plans || (Helium10Plans = {}));
export const planGroups = {
    [Helium10Plans.AlaCarte]: "alacarte",
    [Helium10Plans.AlaCarteAnnual]: "alacarte",
    [Helium10Plans.Enterprise]: "enterprise",
    [Helium10Plans.Elite]: "elite",
    [Helium10Plans.Elite399]: "elite",
    [Helium10Plans.EliteQuarter]: "elite",
    [Helium10Plans.EliteAnnual]: "elite",
    [Helium10Plans.SuperchargeYourBrand]: "elite",
    [Helium10Plans.SuperchargeYourBrandAnnual]: "elite",
    [Helium10Plans.Diamond]: "diamond",
    [Helium10Plans.Diamond199]: "diamond",
    [Helium10Plans.DiamondAnnual]: "diamond",
    [Helium10Plans.DiamondAnnual1999]: "diamond",
    [Helium10Plans.Diamond249]: "diamond",
    [Helium10Plans.DiamondAnnual249]: "diamond",
    [Helium10Plans.DiamondChinese]: "diamond",
    [Helium10Plans.DiamondChineseAnnual]: "diamond",
    [Helium10Plans.ScaleYourBusiness]: "diamond",
    [Helium10Plans.ScaleYourBusinessAnnual]: "diamond",
    [Helium10Plans.AdtomicScaleYourBusinessBundle]: "diamond",
    [Helium10Plans.AdtomicScaleYourBusinessBundleAnnual]: "diamond",
    [Helium10Plans.Platinum]: "platinum",
    [Helium10Plans.Platinum99]: "platinum",
    [Helium10Plans.PlatinumAnnual]: "platinum",
    [Helium10Plans.PlatinumAnnual999]: "platinum",
    [Helium10Plans.PlatinumFastAction]: "platinum",
    [Helium10Plans.PlatinumChinese]: "platinum",
    [Helium10Plans.PlatinumChineseAnnual]: "platinum",
    [Helium10Plans.StartYourBusiness]: "platinum",
    [Helium10Plans.StartYourBusinessAnnual]: "platinum",
    [Helium10Plans.Gold]: "gold",
    [Helium10Plans.GoldAnnual]: "gold",
    [Helium10Plans.Starter]: "starter",
    [Helium10Plans.Starter39]: "starter",
    [Helium10Plans.StarterAnnual]: "starter",
    [Helium10Plans.StarterAnnual339]: "starter",
    [Helium10Plans.StarterChinese]: "starter",
    [Helium10Plans.StarterChineseAnnual]: "starter",
    [Helium10Plans.Free]: "free",
};
